<template lang="html">
<div class="tab-bar">
    <router-link
      class="tab"
      data-text='Open'
      :to="{
        name: 'ShowCapsule',
        params: { capsuleId: outfit.capsule_id },
        query: queryParams
      }"
    >
      <span class="icon"><i class="pe-7s-look"></i></span>
    </router-link>
    <b-link class="tab" data-text='Remove' @click="showUnstitchOutfitModal">
      <span class="icon"><i class="pe-7s-trash"></i></span>
    </b-link>
  </div>
</template>

<script>
export default {
  mounted() {
    this.outfit.layers.forEach((layer) => {
      const product = layer.products[0];
      this.queryParams[product["layer_slug"]] = product.id;
    });
  },

  props: {
    outfit: {
      type: Object,
    },
  },

  data() {
    return {
      queryParams: {},
    };
  },

  methods: {
    showUnstitchOutfitModal() {
      this.$nextTick(() => {
        this.$modal.show("confirm-unstitch-outfit", {
          outfit: this.outfit,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

$font-size: 12px;
$time: 0.3s;
$border: 1px;
$border-radius: 5px;
$border-color: #5fef8d;
$chip-color: $primary-accent;
$morph-chip-color: $primary-blue;
$selected-bg: rgba(0, 0, 0, 0.1);

@mixin border() {
  border: $border solid $border-color;
  border-right: none;
  &:last-child {
    border-right: $border solid $border-color;
    border-top-right-radius: inherit;
    border-bottom-right-radius: inherit;
  }
  &:first-child {
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
  }
}
.radius {
  border-radius: $border-radius;

  .tab:active::before {
    border-radius: $border-radius !important;
  }
}

.border .tab {
  @include border();
  &:active::before {
    border-radius: inherit !important;
  }
}

.tab-bar {
  display: flex;
  margin: 0;
  margin-top: -20px;
  color: $grey3;
  justify-content: flex-end;
  overflow-x: visible;

  .tab {
    box-sizing: border-box;
    text-decoration: none;
    color: inherit;
    width: 45px;
    height: 45px;
    background: inherit;
    padding: 5px;
    display: inherit;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all $time;

    &:hover::before {
      opacity: 1;
      bottom: 0px;
    }

    &::after {
      content: attr(data-text);
      position: absolute;
      top: 0;
      width: 100%;
      text-align: center;
      color: inherit;
      font-size: $font-size;
      opacity: 0;
      transition: all $time ease-in-out;
    }

    &:hover {
      &::after {
        opacity: 1;
        top: 6px;
      }
      padding-top: 15px;
    }

    &.selected {
      background-color: $selected-bg;
      border-radius: inherit;

      &::after {
        opacity: 1;
        top: 6px;
      }
      &::before {
        opacity: 1;
        bottom: 0px;
      }
      padding-top: 15px;
    }

    .icon {
      color: inherit;
      z-index: 10;
      font-size: 2 * $font-size;
      display: inherit;
      margin-bottom: -25px;

      img,
      i {
        margin: auto;
        height: 2 * $font-size;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/stitchedOutfits/Actions.vue